import React, { PointerEventHandler } from 'react'
import styled from 'styled-components'
import { PageType } from '../../interfaces/types'

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;

  width: 100%;
  padding: 1em;

  border-radius: 10px;

  box-sizing: border-box;

  align-items: center;
  justify-content: center;

  .message {
    font-size: 1.2em;
    text-align: center;
    /* make bold */
    font-weight: bold;
    /* word-break: keep-all; */
  }
`

const MessageCard = (props: {
  setCurrentPage?: (page: PageType, pathname?: string) => void,
  message: string,
  demo: string,
  isManifesto?: boolean
  id?: string
}) => {
  const handleClick: PointerEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault()
    e.stopPropagation()
    console.log(e.currentTarget.id)
    if (props.setCurrentPage) {
      props.setCurrentPage('MYBENEFIT', e.currentTarget.id)
    }
  }
  return (
    <StyledCard
      style={{
        background: props.isManifesto ? '#D2F825' : '#fff'
      }}
      onClick={handleClick}
      id={props.id}
    >
      <div className='message'>{props.message}</div>
      <div className='demo'>{props.demo}</div>
    </StyledCard>
  )
}

export default MessageCard